import styled, { css } from 'styled-components';

export const IconWrapper = styled.div`
  ${({ theme }) => css`
    color: ${theme.color.text.neutral.default};
  `}
`;

export const BloquedTextWrapper = styled.p`
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  display: inline;
`;

export const TotalTruckersWrapper = styled.div<{ $hasLockedDrivers: boolean }>`
  ${({ theme, $hasLockedDrivers }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    min-width: 90px;
    max-width: 90px;

    ${$hasLockedDrivers &&
    css`
      gap: ${theme.spacing.km3};
      width: 100%;
      min-width: 126px;
      max-width: 206px;

      container-type: inline-size;
      container-name: total-truckers;

      @container total-truckers (width <206px) {
        ${BloquedTextWrapper} {
          display: none;
        }
      }
    `}
  `}
`;
